var ReportsModule = /** @class */ (function () {
    function ReportsModule() {
    }
    return ReportsModule;
}());
export { ReportsModule };
